(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dz-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dz-pack-selector')) {
    customElements.define('dz-pack-selector', class extends HTMLElement {
      connectedCallback() {
        this.owner = this.closest('product-info');
        this.quantity = this.owner?.querySelector('input[name="quantity"]');
        if (!this.quantity) return;
        this.variants = JSON.parse(this.querySelector('[data-pack-variants]').textContent);
        this.radios = [...this.querySelectorAll('input[type="radio"]')];
        this.bulk = this.querySelector('[data-bulk-quantity]');
        this.fieldset = this.querySelector('fieldset');
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'PKR',minimumFractionDigits:2,maximumFractionDigits:2});
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) this.select(Number(event.target.value));
          if (event.target === this.bulk) this.select(Math.max(5,Math.floor(Number(this.bulk.value) || 5)));
        }, options);
        this.owner.addEventListener('change', (event) => {
          if (event.target === this.quantity || event.target.name === 'id') this.sync();
        }, options);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.quantity,{attributes:true,attributeFilter:['min','max','step','value']});
        this.fieldset.disabled = false;
        this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
      select(value) {
        const min = Number(this.quantity.min) || 1;
        const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
        const step = Number(this.quantity.step) || 1;
        const desired = Math.min(max, Math.max(min,value));
        this.quantity.value = String(min + Math.floor((desired-min)/step)*step);
        this.quantity.dispatchEvent(new Event('input',{bubbles:true}));
        this.quantity.dispatchEvent(new Event('change',{bubbles:true}));
        this.sync();
      }
      sync() {
        const quantity = Math.max(1,Math.floor(Number(this.quantity.value) || 1));
        const tier = Math.min(quantity,5);
        const min = Number(this.quantity.min) || 1;
        const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
        const step = Number(this.quantity.step) || 1;
        const variantId = this.owner.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || this.dataset.variant;
        const variant = this.variants.find(v => String(v.id) === variantId);
        this.radios.forEach(r => {
          const n=Number(r.value);
          r.checked=n===tier;
          r.disabled=!variant?.available || (n<5 ? n<min || n>max || (n-min)%step!==0 : max<Math.max(5,min));
        });
        this.querySelector('.dz-packs__bulk').hidden=quantity<5;
        this.bulk.value=String(Math.max(5,quantity));
        this.bulk.min=String(Math.max(5,min));
        this.bulk.step=String(step);
        if (Number.isFinite(max)) this.bulk.max=String(max); else this.bulk.removeAttribute('max');
        const percent=quantity>=5?8:quantity===4?7:quantity===3?5:quantity===2?3:0;
        const total=Math.round((variant?.price || 0)*quantity*(100-percent)/100);
        this.querySelector('[data-pack-total]').textContent=this.format.format(total/100);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
